import comp from "./DialogueBoxV3";
export default comp;
